var map = {
	"./alert_camera.png": 133,
	"./alert_microphone.png": 134,
	"./alert_mute.png": 135,
	"./arrow-next.png": 136,
	"./arrow-repeat.png": 137,
	"./audio-icon.png": 138,
	"./avatars/AvatarArabella1.png": 139,
	"./avatars/AvatarArabella2.png": 140,
	"./avatars/AvatarArabella3.png": 141,
	"./avatars/AvatarArabella4.png": 142,
	"./avatars/AvatarArabella5.png": 143,
	"./avatars/AvatarChloe1.png": 144,
	"./avatars/AvatarChloe2.png": 145,
	"./avatars/AvatarChloe3.png": 146,
	"./avatars/AvatarChloe4.png": 147,
	"./avatars/AvatarChloe5.png": 148,
	"./avatars/AvatarChloe6.png": 149,
	"./camera.png": 150,
	"./close-icon.png": 151,
	"./dev_next.png": 152,
	"./dev_prev.png": 153,
	"./difficulty_1.png": 154,
	"./difficulty_1_a.png": 155,
	"./difficulty_1_b.png": 156,
	"./difficulty_2.png": 157,
	"./difficulty_2_a.png": 158,
	"./difficulty_2_b.png": 159,
	"./difficulty_3.png": 160,
	"./difficulty_3_a.png": 161,
	"./difficulty_3_b.png": 162,
	"./difficulty_4.png": 163,
	"./difficulty_4_a.png": 164,
	"./difficulty_4_b.png": 165,
	"./difficulty_5.png": 166,
	"./difficulty_5_a.png": 167,
	"./difficulty_5_b.png": 168,
	"./difficulty_6.png": 169,
	"./difficulty_6_a.png": 170,
	"./difficulty_6_b.png": 171,
	"./dummy_image_chicken.png": 172,
	"./dummy_image_cow.png": 173,
	"./dummy_image_duck.png": 174,
	"./dummy_image_horse.png": 175,
	"./dummy_image_mini-adventure.png": 176,
	"./dummy_image_pig.png": 177,
	"./dummy_image_sheep.png": 178,
	"./fantastisch.mp3": 179,
	"./ga_zo_door_2.mp3": 180,
	"./gevonden_rustig.mp3": 181,
	"./geweldig_1.mp3": 182,
	"./gewonnen_level_1_opgewekt.mp3": 183,
	"./gewonnen_level_2_opgewekt.mp3": 184,
	"./gewonnen_level_3_opgewekt.mp3": 185,
	"./gewonnen_level_4_opgewekt.mp3": 186,
	"./gewonnen_level_5_opgewekt.mp3": 187,
	"./gewonnen_level_6_opgewekt.mp3": 188,
	"./glow.png": 189,
	"./goed_gedaan.mp3": 190,
	"./goed_zo_2.mp3": 191,
	"./level_1_rustig.mp3": 192,
	"./level_2_rustig.mp3": 193,
	"./level_3_rustig.mp3": 194,
	"./level_4_rustig.mp3": 195,
	"./level_5_rustig.mp3": 196,
	"./level_6_rustig.mp3": 197,
	"./nog_een_keer.mp3": 198,
	"./ok_button.png": 199,
	"./prize_1.png": 200,
	"./prize_2.png": 201,
	"./prize_3.png": 202,
	"./prize_4.png": 203,
	"./prize_5.png": 204,
	"./prize_6.png": 205,
	"./progress.png": 206,
	"./super_opgewekt.mp3": 207,
	"./terug_2.mp3": 208,
	"./treasury.png": 209,
	"./verder_spelen.mp3": 210,
	"./wat_knap_2.mp3": 211,
	"./wauw_rustig.mp3": 212
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared ^\.\/.*$
// module id = 229
// module chunks = 0